import { api } from '@/lib/api'
import type { CreateRoleRequest, Permission, Role, UpdateRoleRequest } from './types'

export async function listRoles(): Promise<Role[]> {
  const r = await api.get<Role[]>('/api/access/roles')
  return r.data
}

export async function createRole(payload: CreateRoleRequest): Promise<Role> {
  const r = await api.post<Role>('/api/access/roles', payload)
  return r.data
}

export async function updateRole(code: string, payload: UpdateRoleRequest): Promise<Role> {
  const r = await api.put<Role>(`/api/access/roles/${code}`, payload)
  return r.data
}

export async function deleteRole(code: string): Promise<void> {
  await api.delete(`/api/access/roles/${code}`)
}

export async function getAllPermissions(): Promise<Permission[]> {
  const r = await api.get<Permission[]>('/api/access/permissions')
  return r.data
}

export async function getRolePermissions(code: string): Promise<string[]> {
  const r = await api.get<string[]>(`/api/access/roles/${code}/permissions`)
  return r.data
}

export async function setRolePermissions(code: string, codes: string[]): Promise<void> {
  await api.put(`/api/access/roles/${code}/permissions`, { codes })
}
